var _circle, _circle2, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeryBadHealthScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F33939",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 20.5714,
    fill: "#F33939",
    fillOpacity: 0.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 16.4571,
    fill: "#F33939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 27.3333H24.0067",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.8333V20.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6272 17.57C25.6489 17.207 25.2146 15.7539 24.0997 15.6704C24.0334 15.6654 23.9668 15.6654 23.9005 15.6704C22.7856 15.7539 22.3513 17.2069 21.373 17.57C20.3372 17.9544 18.9208 17.1666 18.0438 18.0436C17.1996 18.8878 17.9466 20.3583 17.5702 21.3729C17.1853 22.4096 15.576 22.8384 15.6705 24.0996C15.7541 25.2145 17.2071 25.6488 17.5702 26.6271C17.9466 27.6417 17.1995 29.1122 18.0438 29.9563C18.9207 30.8334 20.3372 30.0459 21.373 30.4299C22.351 30.7935 22.7858 32.2462 23.9005 32.3296C23.9668 32.3346 24.0334 32.3346 24.0997 32.3296C25.2144 32.2462 25.6493 30.7934 26.6272 30.4299C27.6418 30.0537 29.1124 30.8006 29.9564 29.9563C30.8625 29.0504 29.9895 27.5817 30.4682 26.535C30.9106 25.5712 32.4218 25.1199 32.3297 23.9004C32.2463 22.7857 30.7936 22.3508 30.43 21.3729C30.046 20.337 30.8335 18.9206 29.9564 18.0436C29.0794 17.1665 27.663 17.9544 26.6272 17.57Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryBadHealthScore);
export default __webpack_public_path__ + "static/media/very-bad-health-score.429100fd7fd0770558f9651b21a1bee0.svg";
export { ForwardRef as ReactComponent };